import standardSections from './Standard-City';
import { cityMap } from './Cities';

const sections = standardSections("dashtwincities@gmail.com",
    '<p>DASH 9 will start at:</p>' +
    'Riverplace Exhibition Hall - Room 145 & Atrium<br/>' +
    '43 Main Street SE<br/>' +
    'Minneapolis, MN 55414');

cityMap['minneapolis'].sections = sections;
cityMap['minneapolis'].eventStartLocation = 'Riverplace Exhibition Hall - Room 145 & Atrium<br/>' +
    '43 Main Street SE<br/>' +
    'Minneapolis, MN 55414';





// WEBPACK FOOTER //
// ./src/cities/Minneapolis.js